import { InjectionToken } from '@angular/core';

export const CONTRACTS_DATA_CONFIG = new InjectionToken<ContractsDataConfig>(
  'contracts-data-config',
);

export type ContractsDataConfig = {
  apiPrefix: string;
};
